import React from 'react';
import { Crown } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { cn } from '../../../lib/utils';
import useLimits from '../../plan/hooks/limits';
import { usePlan } from '../../plan/hooks/plan';

interface TranscriptLimitWarningProps {
  position?: 'top' | 'bottom';
}

const ICON_STYLE = {
  width: 20,
  height: 20,
  strokeWidth: 2,
};

const TranscriptLimitWarning: React.FC<TranscriptLimitWarningProps> = ({
  position = 'top',
}) => {
  const guardLimits = useLimits();
  const { isPlan } = usePlan();

  // Don't show upgrade CTA to enterprise users
  if (isPlan(['ENTERPRISE'])) {
    return null;
  }

  const handleUpgradeClick = () => {
    guardLimits('fullTranscript', () => {
      // This will trigger the upgrade modal
      console.log('Upgrade process initiated for transcript feature.');
    });
  };

  return (
    <div
      className={cn(
        'animate-in fade-in duration-500 flex items-center justify-center py-4 px-6 mx-4 sm:mx-0 rounded-lg bg-primary/10 transition-all duration-300 ease-in-out z-50',
        position === 'top' ? 'sticky top-0 mb-4' : 'relative mt-4',
      )}
      role="alert"
    >
      <div className="flex items-center justify-between w-full gap-4 text-yellow-600">
        <div className="flex items-center gap-4">
          <Crown className="text-yellow-600" style={ICON_STYLE} />
          <div>
            <p className="font-semibold text-foreground mb-1">
              You have reached your transcription limit
            </p>
            <p className="text-xs text-muted-foreground">
              Upgrade your plan to increase your limit.
            </p>
          </div>
        </div>
        <Button
          onClick={handleUpgradeClick}
          size="sm"
          className="ml-4 px-4 py-1.5 font-semibold transition-all duration-200 ease-in-out"
        >
          Upgrade Now
        </Button>
      </div>
    </div>
  );
};

export default TranscriptLimitWarning;
